import { createBaseState, type BaseState } from './base'
import {
  createManualPayloadsState,
  type ManualPayloadsState,
} from './manualPayloads'

/**
 * Stato completo: somma dei vari slice (es: base + manualPayloads).
 */
export type PromoEngineState = BaseState & ManualPayloadsState

export const createState = (): PromoEngineState => ({
  ...createBaseState(),
  ...createManualPayloadsState(),
})
